import { STATIC_CHANNELS } from './channels_static.js';
import { DYNAMIC_CHANNELS } from './channels_dynamic.js';

export const CHANNELS = [
    ...[...STATIC_CHANNELS.entries()].map(([id, info]) => ({
        id,
        name: info.name,
        type: 'free',
        kind: 'static',
    })),
    ...[...DYNAMIC_CHANNELS.entries()].map(([name, info]) => ({
        id: info.id,
        name,
        type: info.type,
        kind: 'dynamic',
    }))
];